import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { CentralAuthGuard } from './guards/central-auth.guard';
import { TenantAuthGuard } from './guards/tenant-auth.guard';
import { CentralForwardGuard } from './guards/central-forward.guard';
import { TenantForwardGuard } from './guards/tenant-forward.guard';

const routes: Routes = [
  {
    path: 'welcome',
    loadChildren: () => import('./pages/auth/central/welcome/welcome.module').then(m => m.WelcomePageModule),
  },
  {
    path: '',
    redirectTo: 'welcome',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/auth/central/login/login.module').then(m => m.LoginPageModule),
    canActivate: [CentralForwardGuard]
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/auth/central/register/register.module').then(m => m.RegisterPageModule),
    canActivate: [CentralForwardGuard]
  },
  {
    path: 'forgot',
    loadChildren: () => import('./pages/auth/central/forgot/forgot.module').then(m => m.ForgotPageModule),
    canActivate: [CentralForwardGuard]
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule),
    canActivate: [TenantAuthGuard]
  },
  {
    path: 'expenses',
    loadChildren: () => import('./pages/expenses/expenses.module').then( m => m.ExpensesPageModule),
    canActivate: [TenantAuthGuard]
  },
  {
    path: 'timesheet',
    loadChildren: () => import('./pages/timesheet/timesheet.module').then( m => m.TimesheetPageModule),
    canActivate: [TenantAuthGuard]
  },
  {
    path: 'timesheet/:timesheet_id',
    loadChildren: () => import('./pages/timesheet/edit/edit.module').then( m => m.EditPageModule),
    canActivate: [TenantAuthGuard]
  },
  {
    path: 'people',
    loadChildren: () => import('./pages/people/people.module').then(m => m.PeoplePageModule),
    canActivate: [TenantAuthGuard]
  },
  {
    path: 'people/:user_id',
    loadChildren: () => import('./pages/people/details/details.module').then(m => m.DetailsPageModule),
    canActivate: [TenantAuthGuard]
  },
  {
    path: 'people/edit/:user_id',
    loadChildren: () => import('./pages/people/edit/edit.module').then(m => m.EditPersonPageModule),
    canActivate: [TenantAuthGuard]
  },
  {
    path: 'settings',
    loadChildren: () => import('./pages/settings/settings.module').then( m => m.SettingsPageModule),
    canActivate: [TenantAuthGuard]
  },
  {
    path: 'admin',
    loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminPageModule),
    canActivate: [TenantAuthGuard]
  },
  {
    path: 'launch',
    loadChildren: () => import('./pages/auth/central/launch/launch.module').then(m => m.LaunchPageModule),
    canActivate: [CentralAuthGuard, TenantForwardGuard]
  },
  {
    path: 'reset/:token/:email',
    loadChildren: () => import('./pages/auth/central/reset/reset.module').then( m => m.ResetPageModule)
  },
  {
    path: 'invoice',
    loadChildren: () => import('./pages/invoice/invoice.module').then( m => m.InvoicePageModule),
    canActivate: [TenantAuthGuard]
  },
  {
    path: 'employment',
    loadChildren: () => import('./pages/employment/employment.module').then( m => m.EmploymentPageModule),
    canActivate: [TenantAuthGuard]
  },
  {
    path: 'employment/:user_id',
    loadChildren: () => import('./pages/employment/details/details.module').then(m => m.DetailsPageModule),
    canActivate: [TenantAuthGuard]
  },
  {
    path: 'employment/edit/:user_id',
    loadChildren: () => import('./pages/employment/edit/edit.module').then( m => m.EditPageModule),
    canActivate: [TenantAuthGuard]
  },
  {
    path: 'bexio-invoice',
    loadChildren: () => import('./pages/bexio-invoice/bexio-invoice.module').then( m => m.BexioInvoicePageModule)
  },
  /*
  * -----------------------------------------------------
  * -----------------------------------------------------
  * -----------------------------------------------------
  */
  {
    path: 'customization',
    loadChildren: () => import('./pages/customization/customization.module').then( m => m.CustomizationPageModule),
    canActivate: [TenantAuthGuard]
  },
  /*
  * -----------------------------------------------------
  * -----------------------------------------------------
  * -----------------------------------------------------
  */



];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
